var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 44,
    viewBox: "0 0 17 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_36116",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.448 0.783203H0.312012V43.6918H16.448V0.783203Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_36116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75098 25.9159L12.567 10.8969C12.853 10.2659 12.853 9.24292 12.567 8.61192C12.28 7.98092 11.816 7.98092 11.529 8.61192L4.19498 24.7729C4.05698 25.0759 3.97998 25.4869 3.97998 25.9159C3.97998 26.3439 4.05698 26.7549 4.19498 27.0579L11.529 43.2179C11.673 43.5339 11.86 43.6919 12.048 43.6919C12.236 43.6919 12.423 43.5339 12.567 43.2179C12.853 42.5869 12.853 41.5639 12.567 40.9329L5.75098 25.9159Z",
    stroke: "#916DE1",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.7b3ec82277abbd0d486e3d8d9e13c556.svg";
export { ForwardRef as ReactComponent };